import cn from 'classnames';
import type React from 'react';
import * as st from './styles.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  disabled: boolean;
  handler?: () => void;
}

const ButtonLink: React.FC<Props> = ({ children, disabled, handler, className }) => {
  return (
    // <div className={st.wrapper}>
    <button type="button" className={cn(st.btn, className)} disabled={disabled} onClick={handler}>
      {children}
    </button>
    // </div>
  );
};

export default ButtonLink;
